






























































import CandidatePortalLogo from './CandidatePortalLogo.vue';
import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { ForgotPasswordRequest } from '../models/userdata/forgotpasswordreqeust';
import axios from 'axios';
import router from '../router';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ForgotPassword',
  components: {
    CandidatePortalLogo,
  },
})
export default class ForgotPassword extends Vue {
  $wlToastr: any;
  private request: ForgotPasswordRequest = new ForgotPasswordRequest();

  public get getCompanyCode(): string {
    return vxm.jobs.BrandingInfo.companycode;
  }
  async submitEmail() {
    this.request.companyCode = this.getCompanyCode;
    if (this.request.userEmail === '') {
      this.$wlToastr(
        'error',
        this.$t('forgotpassword.email.required'),
        'Forgot Password',
      );
    } else {
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      console.log('Forgot password');
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/forgotPassword',
        this.request,
        {
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      console.log(resp);
      if (resp.data.success) {
        this.$wlToastr(
          'success',
          this.$t('changepassword.success.message'),
          'Forgot Password',
        );
        router.push('Login');
      } else {
        this.$wlToastr('error', resp.data.errorMessage, 'Forgot Password');
      }
    }
  }
  cancelReq() {
    this.request.userEmail = '';
  }
}
